package com.hyperether.goodjob.util

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

object URLManager {
    // A StateFlow to hold the URL content, initially null
    private val _urlContent = MutableStateFlow<String?>(null)
    val urlContent: StateFlow<String?> get() = _urlContent

    // Function to update the URL content
    fun updateUrlContent(newContent: String) {
        _urlContent.value = newContent
    }

    fun extractEmailFromUrl(url: String?): String? {
        if (url == null) return null
        val queryStart = url.indexOf('?')
        if (queryStart == -1) return null

        val query = url.substring(queryStart + 1).replace("?", "&")

        val params = query.split("&")
        for (param in params) {
            val pair = param.split("=")
            if (pair.size == 2 && pair[0] == "email") {
                return pair[1]
            }
        }
        return null
    }
}